export default __webpack_public_path__ + "static/bunker-web-1-ccec4797071291f1bf27d96b0025b8cc.jpg";